import { useSearchParams } from "react-router";

import useTypedContext from "hooks/useTypedContext";
import { SpacesContext } from "views/Account/SpacesProvider";
import { URL_SEARCH_KEY, URL_SORT_DIRECTION, URL_SORT_KEY } from "constants/urlQueryKeys";
import { decodeURIParam } from "utils/urls";
import { SearchQueryOrderDirection } from "types/generated";

import SpacesTreeGridList from "./List";
import { SpacesViewContext } from "../Context";
import { FilterItemKeys } from "./constants";

const SpacesTreeGrid = () => {
  const { spaces } = useTypedContext(SpacesContext);
  const { isRootAdmin, canNonRootAdminCreateSpace } = useTypedContext(SpacesViewContext);
  const [searchParams] = useSearchParams();
  const searchQuery = decodeURIParam(searchParams.get(URL_SEARCH_KEY));

  const sortDirection = searchParams.get(URL_SORT_DIRECTION) as SearchQueryOrderDirection;

  const sortBy: FilterItemKeys = searchParams.get(URL_SORT_KEY) as FilterItemKeys;

  return (
    <SpacesTreeGridList
      isRootAdmin={isRootAdmin}
      spaces={spaces}
      searchQuery={searchQuery}
      sortBy={sortBy}
      sortDirection={sortDirection}
      canNonRootAdminCreateSpace={canNonRootAdminCreateSpace}
    />
  );
};

export default SpacesTreeGrid;
